import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { CoordinatesType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const processLatLngs = (payload: CoordinatesType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}processLatLngs`, payload);
      dispatch({
        type: action_types.GET_DRIVE_TIME,
        data: { payload: data?.driveTimes, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_DRIVE_TIME,
        data: {},
      });
    }
  };
};

export const removeLatLngs = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_DRIVE_TIME,
      data: { payload: [], loading: true },
    });
  };
};
